/**
 * ヘッダーのスクロール制御
 * 下スクロールで隠す、上スクロールで再表示
 * 先頭付近は常時表示、Offcanvas開閉時の対応
 */
(() => {
    const header = document.querySelector('[data-header]');
    const toggler = document.querySelector('.navbar-toggler');
    const offcanvasEl = document.getElementById('globalOffcanvas');
    if (!header) return;

    let lastY = window.pageYOffset;
    let ticking = false;
    const THRESHOLD_HIDE = 8;
    const THRESHOLD_SHOW = 6;
    const TOP_LOCK = 24;

    const update = () => {
        const y = window.pageYOffset;
        const dy = y - lastY;

        // 先頭付近は常に表示
        if (y <= TOP_LOCK) {
            header.classList.remove('is-hidden');
            header.classList.add('is-top');
            lastY = y;
            ticking = false;
            return;
        } else {
            header.classList.remove('is-top');
        }

        // 下方向に一定以上 = 隠す
        if (dy > THRESHOLD_HIDE) {
            header.classList.add('is-hidden');
        }
        // 上方向に一定以上 = 再表示
        else if (dy < -THRESHOLD_SHOW) {
            header.classList.remove('is-hidden');
        }

        lastY = y;
        ticking = false;
    };

    window.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
        }
    }, { passive: true });

    // Offcanvas開閉時の制御
    if (offcanvasEl) {
        offcanvasEl.addEventListener('show.bs.offcanvas', () => {
            header.classList.remove('is-hidden');
            header.classList.add('is-locked');
            if (toggler) toggler.setAttribute('aria-expanded', 'true');
        });
        offcanvasEl.addEventListener('hidden.bs.offcanvas', () => {
            header.classList.remove('is-locked');
            if (toggler) toggler.setAttribute('aria-expanded', 'false');
        });
    }
})();